// 機体への MQTT 接続設定。
// クラウド経由では AWS IoT Core (Cognito Identity Pool + SigV4)、
// 開発時はローカル MQTT ブローカーへ接続する。
// 実際の接続ロジック (mqttService) はプレイバック一覧表示のステップで実装する。

export interface IotConfig {
  awsRegion: string
  awsIotEndpoint: string
  // AWS IoT エンドポイントが設定されていれば true。未設定ならローカル MQTT を使う。
  // 一時認証情報は API サーバー (/api/iot/sites/{site}/credentials) から取得するため
  // ここでは扱わない。
  awsIotEnabled: boolean
  // ローカル MQTT ブローカー (開発用 / 機体に直接接続する場合)
  mqttHost: string
  mqttPort: string
}

export function getIotConfig(): IotConfig {
  const awsIotEndpoint = import.meta.env.VITE_AWS_IOT_ENDPOINT || ''

  return {
    awsRegion: import.meta.env.VITE_AWS_REGION || 'ap-northeast-1',
    awsIotEndpoint,
    awsIotEnabled: Boolean(awsIotEndpoint),
    mqttHost: import.meta.env.VITE_MQTT_HOST || 'localhost',
    mqttPort: import.meta.env.VITE_MQTT_PORT || '9001',
  }
}
